import {MEMBERS_ERROR, MEMBERS_SUCCESS, MEMBERS_REQUEST} from '../actions/members'
import {AUTH_LOGOUT} from '../actions/auth'
// import apiCall from '@/utils/api.js'
// import Vue from 'vue'

import { mock, memberData } from '../../utils/mockdata';
var axios = require('axios');


export default {

  state: {
    status: '',
    members: {},
  },
  
  getters: {
    getMembers: state => state.members,
    isMembersLoaded: state => state.members.length > 0,
  },
  actions: {
    
    async fetchMembers({commit}, aid) {
      commit(MEMBERS_REQUEST);

      await mock.onGet('/members', { params: { accountid: aid } }).reply(
        200, {data: memberData}
      );
        
      await axios.get('/members', { params: { accountid: aid } } )
      .then(resp => {
          commit(MEMBERS_SUCCESS, resp.data.data)
          // commit('setAccount', resp.data.data),
          // console.log("members fetched. > "+JSON.stringify(resp.data.data))
      })
      .catch(resp => {
        console.log("failed>  "+resp)
          commit(MEMBERS_ERROR);
          // if resp is unauthorized, logout, to
          dispatch(AUTH_LOGOUT)
      })  
    },
    async updateMember({commit}, member) {
      commit('updateMember', member)
    },
    // },
    // saveMembers({commit}, members) {
    //   // commit('saveAccountProfile', accoutprofile)
    //   commit(MEMBERS_SUCCESS, members)
    // },
    addNewMember({commit}, member) {
      commit('addNewMember', member)
  }, 
  deleteMember({commit}, member) {
      commit('deleteMember', member)
  }

  },
  mutations: {
    [MEMBERS_REQUEST]: (state) => {
      state.status = 'loading'
    },
    [MEMBERS_SUCCESS]: (state, members) => {
      state.status = 'success';
      state.members = members
    },
    [MEMBERS_ERROR]: (state) => {
      state.status = 'error'
    },
    [AUTH_LOGOUT]: (state) => {
      state.members = []
    },
    // saveMembers: (state, members) => {
    //   state.members = members
    // },
    updateMember: (state, updmember) => {
      // pushToArray(state.contacts, contact) //... NOT WORKING properly

      const index = state.members.findIndex(member => member.id === updmember.id)
      if (index !== -1) {
          state.members.splice(index, 1, updmember)
      }
      // console.log("... > "+ JSON.stringify(updcontact))
    },
    addNewMember: (state, addmember) => {
      // if MOCK -> set ID
      addmember.id = 'mock_'+new Date().getTime().toString()
      
      state.members.unshift(addmember)
    },
    deleteMember: (state, delmember) => {
      const index = state.members.findIndex(member => member.id === delmember.id)
      if (index !== -1) {
          state.members.splice(index, 1)
      }
    },

  },
  

}

// == Default structure ==
// export default {
//   state: {},
//   getters: {},
//   actions: {},
//   mutations: {},
// }
